import { CommonModule } from "@angular/common";
import { Component, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "app-points-selector",
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: "./points-selector.component.html",
  styleUrl: "./points-selector.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PointsSelectorComponent),
      multi: true,
    },
  ],
})
export class PointsSelectorComponent implements ControlValueAccessor {
  readonly scores = Array.from({ length: 10 }, (_, index) => index + 1);
  value = 5;
  disabled = false;

  private onChange: (value: number) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  select(score: number): void {
    if (this.disabled) return;

    this.value = score;
    this.onChange(score);
    this.onTouched();
  }

  writeValue(value: number | string | null): void {
    const score = Number(value);
    this.value = Number.isInteger(score) && score >= 1 && score <= 10 ? score : 5;
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }
}
